import { render, staticRenderFns } from "./ShopProfileSection.vue?vue&type=template&id=5dbc2b50&scoped=true&"
import script from "./ShopProfileSection.vue?vue&type=script&lang=js&"
export * from "./ShopProfileSection.vue?vue&type=script&lang=js&"
import style0 from "./ShopProfileSection.vue?vue&type=style&index=0&id=5dbc2b50&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbc2b50",
  null
  
)

export default component.exports